// extracted by mini-css-extract-plugin
export default {"card":"card--wcp7b","header":"header--ld5dk","title":"title--KNhYB","action":"action--Ptotx","actionsWrapper":"actionsWrapper--yIa1F"};